import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import './line.css'

export class GraphicLine extends Component {

  render() {
    const { data, width, height } = this.props
    return (
      <LineChart
        width={width || 680}
        height={height || 354}
        data={data}
      // margin={{
      //   top: 5, right: 30, left: 20, bottom: 5,
      // }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="x" />
        <YAxis label={{ value: "cantidad" }} width={120} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="accesos" stroke="#2E97CF" activeDot={{ r: 8 }} />
      </LineChart>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(GraphicLine)))
